import { Component, OnInit, Input } from '@angular/core';
import { CaseService } from '../../../shared/services/case.service';
import { UntypedFormBuilder, FormControl, Validators, FormArray } from '@angular/forms';
import { UserService } from '../../../shared/services/user.service';
import { ComparerService } from '../../../shared/utility/comparer';
import { AuditService } from '../../../shared/services/audit.service';
import { faHistory} from '@fortawesome/pro-light-svg-icons';
import { AuditFormComponent } from '../../audit-form/audit-form.component';
import { AuthService } from '../../../auth/auth.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalService } from 'src/app/shared/services/modal.service';

@Component({
  selector: 'app-broker-details',
  templateUrl: './broker-details.component.html',
  styleUrls: ['./broker-details.component.scss']
})
export class BrokerDetailsComponent implements OnInit {

  @Input() caseId: number = -1;
  viewInit = false;
  faUsers: any[] = [];

  faHistory = faHistory;

  brokerDetails = this.fb.group({
    equityReleaseCaseId: [],
    caseId: [],
    faUser:[],
    faUserId: [],
    financialAdvisorCompanyName: '',
    brokerReference: '',
    financialAdvisorFullName: '',
    financialAdvisorContactNumber: '',
    financialAdvisorFee: []
  }, { });

  initialForm = this.fb.group({
    equityReleaseCaseId: [],
    caseId: [],
    faUser:[],
    faUserId: [],
    financialAdvisorCompanyName: '',
    brokerReference: '',
    financialAdvisorFullName: '',
    financialAdvisorContactNumber: '',
    financialAdvisorFee: []
  }, { });

  constructor(
  public activeModal: NgbActiveModal,
  private caseService: CaseService,
  private userService: UserService,
  private fb: UntypedFormBuilder,
  private comp: ComparerService,
  private auditService: AuditService,
  private modalService: ModalService,
  public authService: AuthService) {
  }

  ngOnInit(): void {
     this.caseService.getEquityReleaseBrokerDetails(this.caseId).subscribe(response => {

      this.brokerDetails.patchValue(response.brokerDetails);
      this.initialForm.patchValue(response.brokerDetails);

      this.userService.companyGroupUsers(response.brokerDetails.financialAdvisorCompanyId).subscribe(result => {
        this.faUsers = result;
      });
    });


    this.brokerDetails.get('faUserId')!.valueChanges.subscribe(value => {

      this.userService.basicUserDetails(value).subscribe(result => {
        this.brokerDetails.controls["faUser"].patchValue(result);
      });

  });
  }

  close(){

    if(this.comp.objectsDifferent(this.initialForm.value, this.brokerDetails.value))
    {
      this.auditService.auditForm(this.caseId, 'BrokerDetails', this.initialForm.value, this.brokerDetails.value).subscribe((response : any) => {
        this.activeModal.dismiss();
      });
    }
    else
      this.activeModal.dismiss();
  }

  openAuditForForm(){

    const modalRef = this.modalService.openWithOptions(AuditFormComponent, {size: 'xl', scrollable: true});
    modalRef.componentInstance.caseId = this.caseId;
    modalRef.componentInstance.formName = "BrokerDetails";

  }

  updateField(){

    this.caseService.updateEquityReleaseBrokerDetails(this.brokerDetails.value).subscribe((response : any) => {

    }, (error : any) => {
    });
  }


}
